import * as session from '../clients/shell/session';

//FIXME breakchange when turn session to clients, adjust the reference at composer and adpter
export default { session };
